import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { authManager } from "src/main";
import { routes } from "src/routes";
import { useNavigate } from "react-router-dom";

export function SignOut() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    useEffect(() => {
        authManager.signOut();
        localStorage.clear()
        sessionStorage.clear()
        queryClient.invalidateQueries();
        navigate(routes.Login.url());
    },[authManager, queryClient])
    return <></>
}